module.exports = __webpack_public_path__ + "img/halfrate.4f8b4d30.svg";